// Service type constants
export const SERVICE_TYPES = {
  WHATSAPP: 'whatsapp',
  SMS: 'sms',
  VIBER: 'viber',
} as const;

// Icon mapping for different service types
export const SERVICE_ICONS: Record<string, string> = {
  [SERVICE_TYPES.WHATSAPP]: '/images/svg/integrations/whatsapp.svg',
  [SERVICE_TYPES.SMS]: '/images/svg/integrations/sms.svg',
  [SERVICE_TYPES.VIBER]: '/images/svg/integrations/viber.svg',
};

// Service name mapping
export const SERVICE_NAMES: Record<string, string> = {
  [SERVICE_TYPES.WHATSAPP]: 'WhatsApp',
  [SERVICE_TYPES.SMS]: 'SMS',
  [SERVICE_TYPES.VIBER]: 'Viber',
};

// Default fallback icon
export const DEFAULT_SERVICE_ICON = '📞';

// Helper functions
export const getServiceIcon = (type: string): string => {
  return SERVICE_ICONS[type.toLowerCase()] || DEFAULT_SERVICE_ICON;
};

export const getServiceName = (type: string): string => {
  if (!type) return 'Unknown Service';
  
  const normalizedType = type.toLowerCase();
  return SERVICE_NAMES[normalizedType] || type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
}; 